import React, {useState} from "react";
import { Table, Tag, Spin } from "antd";
import dayjs from "dayjs";
import { DateFormat } from "../Components/Constant";
import {convertDateToUserTimezone} from '../Components/Utility';

const ElectricityLogs = ({ logEntries, logDataLoading }) => {
  const [currentPage, setCurrentPage] = useState(1);
  // Filter out relevant electricity data
  const electricityLogs = logEntries.map((log) => ({
      date: convertDateToUserTimezone(log.Date,DateFormat),
    meter_number: log.ElectricityLog?.MeterNumber || null,
    morning_reading: log.MorningReading || 0,
    evening_reading: log.EveningReading || 0,
    alerts: log.Alert || [],
  })).filter((log) => log.meter_number); // Remove entries where jcb_number is missing


  // Calculate average consumption
  const averageConsumption =
    electricityLogs.length > 0
      ? electricityLogs.reduce(
          (acc, log) => acc + (log.evening_reading - log.morning_reading),
          0
        ) / electricityLogs.length
      : 0;

  const columns = [
    { title: "Date", dataIndex: "date", key: "date" },
    { title: "Meter Number", dataIndex: "meter_number", key: "meter_number" },
    { title: "Morning Reading (kWh)", dataIndex: "morning_reading", key: "morning_reading" },
    { title: "Evening Reading (kWh)", dataIndex: "evening_reading", key: "evening_reading" },
    {
      title: "Consumption (kWh)",
      render: (_, record) => record.evening_reading - record.morning_reading,
      key: "consumption",
    },
    {
      title: "Alerts",
      render: (_, record) => {
        const prevLog = electricityLogs.find(
          (l) => l.date === dayjs(record.date).subtract(1, "day").format("DD/MM/YYYY")
        );
        const consumption =  record.evening_reading - record.morning_reading;
        // const meterMismatch = prevLog && record.morning_reading !== prevLog.evening_reading;
        // const wrongMeterReadings = record.evening_reading > record.morning_reading;
        const highConsumption = consumption > averageConsumption * 1.5;

        return (
          <>
            {/* {(meterMismatch || record.alerts === 'High') && <Tag color="red">Meter Mismatch</Tag>}
            {wrongMeterReadings && <Tag color="red">Wrong Meter Readings</Tag>} */}
            {highConsumption && <Tag color="orange">High Consumption</Tag>}
            {/* {!meterMismatch && !highConsumption && record.alerts === "Medium" && (
                <Tag color="blue">{record.alerts}</Tag> */}
            {/* )}  */}
            {/* {!meterMismatch && !highConsumption && record.alerts === "Low" && (
                <Tag color="green">{record.alerts}</Tag> */}
            {/* )}    */}
        </>
        );
      },
      key: "electricity_alerts",
      fixed: "right",
    },
  ];

  return (
    <div>
      <h3>Electricity Logs</h3>
      <Spin spinning={logDataLoading}>
      <Table
        dataSource={electricityLogs}
        columns={columns}
        rowKey="date"
        style={{ marginTop: 20 }}
        pagination={{
          current: currentPage,
          showSizeChanger: false,
          onChange: (page, pageSize) => {
            setCurrentPage(page); 
          },              
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
        }} 
        scroll={{ x: "max-width", y: 180 }}
      />
      </Spin>
    </div>
  );
};

export default ElectricityLogs;
